import React, { useState } from "react";
import { Dropdown, Card, Button, Row, Col, ListGroup } from "react-bootstrap";

export const MyPage2 = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const categories = [
    {
      name: "QUESTION",
      items: [
        {
          question_id: "1",
          question_no: "1",
          question_desc: "ini pertanyaan 1 ?",
          question_type: "TEXT",
          question_answer: "Ini jawaban dari pertanyaan 1",
        },
      ],
    },
    {
      name: "SECTION",
      items: [
        {
          question_id: "3",
          question_no: "3",
          question_desc: "ini pertanyaan 3 ?",
          question_type: "TEXT",
          question_answer: "Ini jawaban dari pertanyaan 3",
        },
        {
          question_id: "2",
          question_no: "2",
          question_desc: "ini pertanyaan 2 ?",
          question_type: "TEXT",
          question_answer: "Ini jawaban dari pertanyaan 2",
        },
      ],
    },
    {
      name: "END",
      items: [
        {
          question_id: "END",
          question_no: "2",
          question_desc: "ini pertanyaan 2 ?",
          question_type: "TEXT",
          question_answer: "Ini jawaban dari pertanyaan 2",
        },
      ],
    },
  ];

  const handleSelect = (value) => {
    setSelectedValue(value.question_id);
    setShowDropdown(false); // Sembunyikan dropdown setelah memilih
  };

  const resetValue = () => {
    setSelectedValue(""); // Reset nilai yang dipilih
  };

  return (
    <div className="p-3">
      <Row className="mb-3">
        <Col>
          <Dropdown
            show={showDropdown}
            onToggle={() => setShowDropdown(!showDropdown)}
          >
            <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
              {selectedValue || " + Add Rule"}
            </Dropdown.Toggle>

            <Dropdown.Menu className="p-0">
              <Card className="p-3" style={{ minWidth: "300px" }}>
                {categories.map((category) => (
                  <div key={category.name} className="mb-4">
                    <h6 className="text-muted">{category.name}</h6>
                    <ListGroup>
                      {category.items.map((item) => (
                        <ListGroup.Item
                          key={item.question_id}
                          action
                          active={selectedValue === item.question_id}
                          onClick={() => handleSelect(item)}
                          className={`d-flex justify-content-between align-items-center ${
                            selectedValue === item.question_id
                              ? "bg-primary text-white"
                              : ""
                          }`}
                        >
                          <div>
                            <strong>{item.question_no}.</strong>{" "}
                            {item.question_desc}
                          </div>
                          {selectedValue === item.question_id && (
                            <i className="bi bi-check-circle-fill"></i> // Ikon bootstrap untuk menandai
                          )}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </div>
                ))}
                <div className="d-flex justify-content-between mt-3">
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => setShowDropdown(false)}
                  >
                    Close
                  </Button>
                  {selectedValue && (
                    <Button variant="danger" size="sm" onClick={resetValue}>
                      Remove Selection
                    </Button>
                  )}
                </div>
              </Card>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
    </div>
  );
};
